<template>

</template>
<script>
import store from '@/store'
import request from "@/router/axios";
export default {
  props: {
    uri: {
      type: String
    },
  },
  data() {
    return {
      webSocket: null, // webSocket实例
      lockReconnect: false, // 重连锁，避免多次重连
      maxReconnect: 3,  // 最大重连次数， -1 标识无限重连
      reconnectTime: 0, // 重连尝试次数
      heartbeat: {
        interval: 60 * 1000, // 心跳间隔时间
        timeout: 30 * 1000, // 响应超时时间
        pingTimeoutObj: null, // 延时发送心跳的定时器
        pongTimeoutObj: null, // 接收心跳响应的定时器
        pingMessage: JSON.stringify({type: 'ping'}) // 心跳请求信息
      }
    }
  },
  computed: {
    token() {
      return store.getters.access_token
    },
    tenant() {
      return store.getters.userInfo.tenantId ? store.getters.userInfo.tenantId : 1;
    },
  },
  created() {
    this.initWebSocket()
  },
  destroyed: function () {
    this.webSocket.close()
    this.clearTimeoutObj(this.heartbeat)
  },
  methods: {
    /**
     * 初始化 weoSocket
     */
    initWebSocket() {
      // ws地址
      let host = window.location.host;
      let protocol = window.location.protocol;
      let wsUri
      console.log("protocol---------------",protocol)
      if (protocol ==='http:') {
        wsUri = `ws://${host}${this.uri}?access_token=${this.token}&TENANT-ID=${this.tenant}`
      }else{
        wsUri = `wss://${host}${this.uri}?access_token=${this.token}&TENANT-ID=${this.tenant}`
      }
      console.log("wsUri--------------", wsUri)
      console.log("开始连接websocket--------------")
      // 建立连接
      this.webSocket = new WebSocket(wsUri)
      // 连接成功
      this.webSocket.onopen = this.onOpen
      // 连接错误
      this.webSocket.onerror = this.onError
      // 接收信息
      this.webSocket.onmessage = this.onMessage
      // 连接关闭
      this.webSocket.onclose = this.onClose
    },
    /**
     * 重新连接
     */
    reconnect() {
      if (!this.token) {
        return
      }
      if (this.lockReconnect || (this.maxReconnect !== -1 && this.reconnectTime > this.maxReconnect)) {
        return
      }
      this.lockReconnect = true
      setTimeout(() => {
        this.reconnectTime++
        // 建立新连接
        this.initWebSocket()
        this.lockReconnect = false
      }, 5000)
    },
    /**
     * 清空定时器
     */
    clearTimeoutObj: function (heartbeat) {
      heartbeat.pingTimeoutObj && clearTimeout(heartbeat.pingTimeoutObj)
      heartbeat.pongTimeoutObj && clearTimeout(heartbeat.pongTimeoutObj)
    },
    /**
     * 开启心跳
     */
    startHeartbeat() {
      const webSocket = this.webSocket
      const heartbeat = this.heartbeat
      // 清空定时器
      this.clearTimeoutObj(heartbeat)
      // 延时发送下一次心跳
      heartbeat.pingTimeoutObj = setTimeout(() => {
        // 如果连接正常
        if (webSocket.readyState === 1) {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          webSocket.send(heartbeat.pingMessage)
          // 心跳发送后，如果服务器超时未响应则断开，如果响应了会被重置心跳定时器
          heartbeat.pongTimeoutObj = setTimeout(() => {
            webSocket.close()
          }, heartbeat.timeout)
        } else {
          // 否则重连
          this.reconnect()
        }
      }, heartbeat.interval)
    },
    /**
     * 连接成功事件
     */
    onOpen() {
      console.log('WebSocket connection success')
      const userInfo = store.getters.userInfo;
      if (userInfo.snUserId) {
        //获取推送信息
        this.getReplyMsg()
      }
      //开启心跳
      this.startHeartbeat()
      this.reconnectTime = 0
    },
    getReplyMsg(){
      request({
        url: '/basic/soOrderOperationReply/getReplyMsg',
        method: 'post',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
      })
    },
    /**
     * 连接失败事件
     * @param e
     */
    onError(e) {
      //错误
      console.log(`WebSocket connection error：${e.code} ${e.reason} ${e.wasClean}`)
      //重连
      this.reconnect()
    },
    /**
     * 连接关闭事件
     * @param e
     */
    onClose(e) {
      //关闭
      console.log(`WebSocket connection closed：${e.code} ${e.reason} ${e.wasClean}`)
      //重连
      this.reconnect()
    },
    /**
     * 接收服务器推送的信息
     * @param msgEvent
     */
    onMessage(msgEvent) {
      console.log("msgEvent---------------", msgEvent)
      //收到服务器信息，心跳重置并发送
      this.startHeartbeat()
      const text = msgEvent.data
      const textMsg = JSON.parse(text)
      console.log("textMsg---------------", textMsg)
      if (text.indexOf('pong') > 0) {
        return
      }
      var notifyType = 'info';
      if (textMsg.sendType === 0) {
        notifyType = 'success';
      } else if (textMsg.sendType === 1) {
        notifyType = 'warning';
      } else if (textMsg.sendType === 2) {
        notifyType = 'error';
      }
      //关闭所有
      this.$notify.closeAll();
      let newData = []
      const h = this.$createElement
      newData.push(h('span',null,textMsg.message))
      newData.push(h('div',null,null))
      if (textMsg.orderNo){
        newData.push(h('span',null,'工单号:'))
        newData.push(h('a',{style: "color: #0a84ff;",attrs:{'href':"javascript:;"},on: {
            click:   (event)=>{
              this.toUrl(textMsg.orderNo)
            },
          },},textMsg.orderNo))
      }
      newData.push(h('div',null,null))
      if (textMsg.count!=null){
        newData.push(h('span',null,'点击数字，'))
        newData.push(h('a',{style: "color: #0a84ff;",attrs:{'href':"javascript:;"},on: {
            click: (event)=>{
              this.toUrl(0)
            },
          },},'更多('+textMsg.count+')'))
        newData.push(h('span',null,'待处理记录'))
      }

      this.notify = this.$notify({
        type: notifyType,
        title: textMsg.title,
        // dangerouslyUseHTMLString: true,
        message:h('div',null,newData),
        // message: textMsg.message+'<br>'+(textMsg.orderNo?'工单号:<a style="color: #0a84ff" href="javascript:;" onclick="toUrl('+textMsg.orderNo+')">'+textMsg.orderNo+'</a>':'')+
        // '<br>点击数字，<a style="color: #0a84ff" href="javascript:;" onclick="toUrl(0)">更多('+textMsg.count+')</a>待处理记录',
        // message: this.$createElement('messgaeTemplate', {       // 使用自定义组件
        //   ref: 'messgaeTemplate',
        //   props: {
        //     formData: textMsg
        //   }
        // }),
        offset: 60,
        duration: 0,
        position: 'bottom-right',
        // onClick: () => {
        //   this.notify.close();
        //   if (textMsg.params){
        //     this.$router.push({path: textMsg.url, query: textMsg.params})
        //   }else{
        //     this.$router.push({path: textMsg.url})
        //   }
        //   // this.$router.push({path: '/workorder/business/center/index', query: {index: 1}})
        // }
      })
      // if (textMsg.url) {
      //   this.notify = this.$notify({
      //     type: notifyType,
      //     title: textMsg.title,
      //     dangerouslyUseHTMLString: true,
      //     message: textMsg.message+(textMsg.orderNo?',对应单号:'+textMsg.orderNo:'')+'<br>请点击查看详情',
      //     offset: 60,
      //     duration: textMsg.duration || textMsg.duration == 0 ? textMsg.duration : 3000,
      //     position: 'bottom-right',
      //     onClick: () => {
      //       this.notify.close();
      //       if (textMsg.params){
      //         this.$router.push({path: textMsg.url, query: textMsg.params})
      //       }else{
      //         this.$router.push({path: textMsg.url})
      //       }
      //       // this.$router.push({path: '/workorder/business/center/index', query: {index: 1}})
      //     }
      //   })
      // } else{
      //   //普通消息
      //   this.$notify({
      //     type: notifyType,
      //     title: textMsg.title,
      //     dangerouslyUseHTMLString: true,
      //     message: textMsg.message+(textMsg.orderNo?'对应单号:'+textMsg.orderNo:''),
      //     offset: 60,
      //     duration: textMsg.duration || textMsg.duration == 0 ? textMsg.duration : 3000,
      //     position: 'bottom-right',
      //   })
      //
      // }

    },
    toUrl(orderNo){
      this.$notify.closeAll();
        this.$router.push({
          path: '/workorder/business/messageNotify/index',query: { orderNo: orderNo}
        })
    },
    /**
     * 数据发送
     * @param msg
     */
    send(msg) {
      //数据发送
      this.webSocket.send(msg)
    }
  }
}

</script>
